import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="toggle-columns"
export default class extends Controller {
  static targets = ["checkbox", "column"]

  toggle(event) {
    const columnName = event.target.dataset.column
    const isChecked = event.target.checked

    this.columnTargets.forEach(column => {
      if (column.dataset.column === columnName) {
        column.classList.toggle("hidden", !isChecked)
      }
    })
  }
}
